import { WarrantyType } from "@dune/types";

export const pricingFilesQueryKeys = {
	all: ["pricing-files"] as const,
	urls: () => [...pricingFilesQueryKeys.all, "urls"] as const,
	urlById: (id: number) =>
		[...pricingFilesQueryKeys.urls(), "by-id", id] as const,
	urlByWarrantyTypeAndBinderAmendmentId: (
		warrantyType: WarrantyType,
		binderAmendmentId: number,
	) =>
		[
			...pricingFilesQueryKeys.urls(),
			"by-warranty-type-and-binder-amendment-id",
			warrantyType,
			binderAmendmentId,
		] as const,
};
